import { createBrowserRouter, type DataRouter } from 'react-router';

import PageNotFound from '@helsenorge/core-framework/page-not-found';
import { getPath } from '@helsenorge/framework-utils/hn-page';

import RegistreContainer from './registre';
import MeldeFeilContainer from './registre/register-melding/message-submit';

export const getRouter = (): DataRouter => {
  return createBrowserRouter(
    [
      {
        path: '/melde-feil',
        element: <MeldeFeilContainer />,
      },
      {
        path: '/',
        element: <RegistreContainer />,
      },
      {
        path: '*',
        element: <PageNotFound />,
      },
    ],

    { basename: `/${getPath()}` }
  );
};
